import { ContentType } from "@pdfking/structs"
import type { Sequence } from "@pdfking/tfunc"

/**
 * The content type of the first recognizable name in `names` — a path, url or
 * filename, matched on its extension alone.
 *
 * Always answers: a name whose extension says nothing is opaque bytes, which is
 * exactly what it is. Callers that know better pass their own `fallback`.
 */
export const PathContentType = (
  names: Sequence<string>,
  fallback: ContentType = ContentType.BYTES
): ContentType => {
  for (const s of names) {
    const lower = s.toLowerCase()
    if (lower.endsWith(".jpeg") || lower.endsWith(".jpg")) return ContentType.JPEG
    if (lower.endsWith(".pdf")) return ContentType.PDF
    if (lower.endsWith(".png")) return ContentType.PNG
    if (lower.endsWith(".zip")) return ContentType.ZIP
  }
  return fallback
}
